import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { Observable } from "rxjs";

import { CommunicationMutuelleInfoEntity } from "../entities/communication-mutuelle-info.entity";

@Injectable({ providedIn: 'root' })
export class CommunicationMutuelleInfoService{
    private path: string;

    constructor( //
        @Inject(HttpClient) private httpClient: HttpClient, //
        @Optional() @SkipSelf() previousInstance?: CommunicationMutuelleInfoService
    ){
        if (previousInstance) {
            throw new Error(
                'CommunicationMutuelleInfoService is already loaded. Import it in the AppModule only');
        }
        this.path = (window as any).baseApiPath;
    }

    public getAllCommunicationMutuelleInfo() : Observable<CommunicationMutuelleInfoEntity[]> {
        let url = this.path + "communicationMutuelleInfo"
        let result = this.httpClient.get<CommunicationMutuelleInfoEntity[]>(url);
        return result;
    }
}